import React from 'react'
import { AsyncSelect } from './AsyncSelect'
import { baseUrl } from 'utils/axios'
import { Option } from './Select'

export const UnitSelect = ({
  onChange,
  value,
  width,
  label,
  placeholder,
}: {
  onChange: (value: Option) => void
  value?: Option | null
  width?: string
  label?: string
  placeholder?: string
}) => {
  return (
    <AsyncSelect<{
      id: number
      name: string
    }>
      width={width}
      label={label}
      optionKey='units'
      placeholder={placeholder || 'Select unit'}
      loadOptions={async (search) => {
        const data = await baseUrl.get('/units', {
          params: {
            q: search || undefined,
            page: 1,
            limit: 20,
          },
        })
        console.log(data.data)
        return data.data.map((item) => ({
          id: item.id,
          name: item.name,
        })) as { id: number; name: string }[]
      }}
      decoder={(item) => ({
        label: item.name,
        value: item.id,
      })}
      onChange={(value) => onChange(value)}
      value={
        value
          ? {
              label: value.label,
              value: value.value,
            }
          : null
      }
    />
  )
}
